/**
 * Camada 1 · superficie publica da autenticacao.
 *
 * O SDK do Supabase NAO e reexportado daqui, e isso e a metade da regra que a outra metade
 * (o lint) impoe. Quem consome este pacote enxerga a interface IdentityProvider e uma
 * classe que a cumpre, e mais nada. E o que faz trocar o provedor depois ser escrever
 * uma classe nova, em vez de revisar cada tela do sistema.
 */
export type {
  IdentityProvider,
  MotivoFalhaLogin,
  ResultadoLogin,
  Sessao,
  UsuarioIdentidade,
} from './identity-provider.js';

export { SupabaseIdentityProvider } from './providers/supabase.js';
export type { OpcoesSupabase } from './providers/supabase.js';

export { TelaLogin } from './components/TelaLogin.js';
export type { TelaLoginProps } from './components/TelaLogin.js';

// A CONTA DE TRABALHO DA PLATAFORMA SAIU deste repositorio em 19/09/2026, por decisao do
// fundador: "cds@cds nao tem nada a ver com esse projeto". As contas de teste daqui sao as
// sinteticas da homologacao. Divergencia protegida (`scripts/sincronizar-chassi.sh`).

// A LISTA DE PERMISSAO DE ACESSO, que decide quem entra num ambiente que nao e producao.
// Pela mesma razao da conta de trabalho, a trava de ambiente mora DENTRO de
// `criarProvedorComListaDePermissao`, e nao em quem a chama: espalhar a decisao pelos apps
// faria cada app poder errar sozinho, e o erro seria uma porta aberta.
export {
  criarProvedorComListaDePermissao,
  // Os dois e-mails que entram em TODO app em local e hml, por pedido dele em 02/09/2026.
  DONOS_DA_PLATAFORMA,
  // Quem entra em TODO app em local e hml sem ser dono, por pedido dele em 08/09/2026.
  ACESSO_PERMANENTE,
  lerLista,
  estaAutorizado,
  MENSAGEM_NAO_AUTORIZADO,
} from './providers/lista-de-permissao.js';

// O DICIONARIO DO CHASSI DE ENTRADA REGISTRA-SE SOZINHO, na carga do modulo.
//
// POR QUE AQUI E NAO EM CADA APP: registrar e responsabilidade de quem TEM as frases, e
// quem as tem e este pacote. Deixado a cargo do app, o produto que nascesse amanha teria a
// tela de entrada em portugues no modo ingles ate alguem notar, e "alguem notar" e o
// mecanismo que esta casa nao aceita como garantia.
//
// EFEITO NA IMPORTACAO, e ele e deliberado: importar `@complexity/auth` ja deixa a tela de
// entrada traduzida. E o mesmo padrao que o proprio mecanismo do i18n descreve, onde cada
// pacote registra as proprias frases em vez de existir um arquivo central que ninguem
// mantem.
import { registrarDicionario } from '@complexity/i18n';
import { EN_CHASSI_LOGIN } from './i18n/en.js';

registrarDicionario('en', EN_CHASSI_LOGIN);

export { EN_CHASSI_LOGIN } from './i18n/en.js';
